<div class="v2-pagina reg-pagina">
    <div class="v2-inner">

        <div class="reg-encabezado">
            <div class="reg-icono"><i class="fas fa-gavel"></i></div>
            <div>
                <h1 class="reg-titulo">Reglamento</h1>
                <p class="reg-subtitulo">Documentos oficiales de la Liga Infantil y Juvenil de Béisbol Yucatán A.C.</p>
            </div>
        </div>

        <div class="reg-selector" *ngIf="documentos.length > 1">
            <button type="button" class="reg-doc-tarjeta" *ngFor="let doc of documentos" [class.activa]="doc === documentoActivo" (click)="seleccionarDocumento(doc)">
                <span class="reg-doc-icono"><i [class]="doc.icono"></i></span>
                <span class="reg-doc-textos">
                    <span class="reg-doc-tipo">{{doc.tipo}}</span>
                    <span class="reg-doc-titulo">{{doc.titulo}}</span>
                    <span class="reg-doc-fecha"><i class="far fa-calendar"></i> {{doc.fecha}}</span>
                </span>
            </button>
        </div>

        <div class="reg-cabecera-doc">
            <div class="reg-cabecera-info">
                <span class="reg-badge-tipo"><i [class]="documentoActivo.icono"></i> {{documentoActivo.tipo}}</span>
                <h2 class="reg-doc-nombre">{{documentoActivo.titulo}}</h2>
                <p class="reg-doc-desc">{{documentoActivo.descripcion}}</p>
            </div>
            <a class="reg-btn-descargar" [href]="documentoActivo.archivo" download>
                <i class="fas fa-download"></i> Descargar PDF
            </a>
        </div>

        <div class="reg-puntos-head" *ngIf="documentoActivo.puntos.length > 0">
            <span class="reg-barra"></span>
            <h3 class="reg-puntos-titulo">Puntos importantes</h3>
        </div>
        <div class="reg-puntos" *ngIf="documentoActivo.puntos.length > 0">
            <div class="reg-punto" *ngFor="let punto of documentoActivo.puntos">
                <div class="reg-punto-icono"><i [class]="punto.icono"></i></div>
                <p class="reg-punto-titulo">{{punto.titulo}}</p>
                <p class="reg-punto-texto">{{punto.texto}}</p>
            </div>
        </div>

        <div class="reg-visor">
            <div class="reg-toolbar">
                <div class="reg-toolbar-grupo">
                    <button (click)="paginaAnterior()" [disabled]="pagina <= 1" title="Página anterior"><i class="fas fa-chevron-left"></i></button>
                    <span class="reg-toolbar-texto">Página {{pagina}} de {{totalPaginas > 0 ? totalPaginas : '—'}}</span>
                    <button (click)="paginaSiguiente()" [disabled]="pagina >= totalPaginas" title="Página siguiente"><i class="fas fa-chevron-right"></i></button>
                </div>
                <div class="reg-toolbar-grupo">
                    <button (click)="alejar()" title="Alejar"><i class="fas fa-search-minus"></i></button>
                    <span class="reg-toolbar-texto">{{zoomPorcentaje}}%</span>
                    <button (click)="acercar()" title="Acercar"><i class="fas fa-search-plus"></i></button>
                    <span class="reg-toolbar-sep"></span>
                    <a class="reg-toolbar-descarga" [href]="documentoActivo.archivo" download title="Descargar"><i class="fas fa-download"></i></a>
                    <button (click)="abrirEnPestana()" title="Abrir en otra pestaña"><i class="fas fa-external-link-alt"></i></button>
                </div>
            </div>
            <div class="reg-lienzo">
                <div class="reg-aviso" *ngIf="cargandoPdf"><i class="fas fa-spinner fa-spin"></i> Cargando documento...</div>
                <div class="reg-aviso" *ngIf="errorPdf"><i class="fas fa-exclamation-triangle"></i> No se pudo mostrar el documento, usa el botón de descarga.</div>
                <pdf-viewer [src]="documentoActivo.archivo" [page]="pagina" [show-all]="false" [original-size]="false" [autoresize]="true" [render-text]="false" [zoom]="zoom" (after-load-complete)="pdfCargado($event)" (error)="pdfError($event)"></pdf-viewer>
            </div>
        </div>

    </div>
</div>
